import React from 'react';

function PhoneIcon({ className, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <g id="Communication / phonelink ring">
        <mask
          id="mask0_16_3790"
          width="20"
          height="22"
          x="2"
          y="1"
          maskUnits="userSpaceOnUse"
          style={{ maskType: 'alpha' }}
        >
          <g id="Icon Mask">
            <path
              id="Round"
              fill="#000"
              fillRule="evenodd"
              d="M4.014 1h10c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2h-10c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2m0 19h10V4h-10zm16.63-11.74a.7.7 0 0 0-1.04-.06l-.03.03c-.25.25-.26.65-.05.93 1.26 1.64 1.25 3.87-.02 5.57-.21.28-.19.67.05.92l.05.05c.29.29.76.26 1.03-.05 1.8-2.13 1.8-5.19.01-7.39m-3.27 2.17.06-.06a.687.687 0 0 1 1.1.17c.5.92.5 1.97.01 2.86-.22.4-.77.47-1.09.15l-.08-.08c-.2-.2-.26-.5-.15-.76.21-.49.21-1.03 0-1.52a.69.69 0 0 1 .15-.76"
              clipRule="evenodd"
            />
          </g>
        </mask>
        <g mask="url(#mask0_16_3790)">
          <path id="Color Fill" fill="#858C94" d="M0 0h24v24H0z" />
        </g>
      </g>
    </svg>
  );
}

export default PhoneIcon;
